<template>
    <div>
      <div class="chat-search pt-0 pb-10">
        <div class="element-search"><input placeholder="Search products to add..." type="text" v-on:keyup.enter="onAddProduct()" v-model="searchAssociate"></div>
        </div>
        <EmptyState v-if="associates.length == 0">
          <div slot="empty_state_text">
            No associations
          </div>
        </EmptyState>
        <div class="ae-list-w">
            <div class="ae-list">
                <div class="ae-item" v-for="product in associates">
                    <div class="aei-image" v-if="product.preview && product.preview != null">
                        <div class="user-avatar-w"><img alt="" :src="product.preview"></div>
                    </div>
                    <div class="aei-content">
                        <div class="aei-timestamp">
                            <a class="btn btn-xs btn-danger text-white" @click="removeProductAssociates(product.id_product)">Remove </a>
                        </div>
                        <h6 class="aei-title">{{productDisplayName(product)}}</h6>
                        <div class="aei-sub-title">{{product.brand || '--'}}</div>
                        <div class="aei-sub-title">{{product.category_name || '--'}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyState from '@/components/common/EmptyState'
import Product from '@/mixins/product'

export default {
  props: ['associates', 'parent', 'selectedProduct'],
  data: function () {
    return {
      searchAssociate: ''
    }
  },
  components: {
    EmptyState
  },
  mixins: [Product],
  methods: {
    async onAddProduct () {
      var self = this
      await this.addProductAssociates()
      setTimeout(function () {
        self.$emit('productAssociatesInterface')
      }, 2000)

      self.$store.dispatch('updateToast', {
        text: 'Association added',
        show: true
      })
      this.searchAssociate = ''
    },
    removeProductAssociates: function (id_product_associated) {
      var self = this
      const url = '/productdesk/product/associate/delete'
      let data = {
        'id_product': self.selectedProduct.id_product,
        'id_product_associated': id_product_associated
      }

      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Association removed',
            show: true
          })
          self.$emit('productAssociatesInterface')
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingProduct = false
        })
		    },
    checkActiveClass: function (product) {
      if (this.selectedProduct != null) {
        return (product.id_product == this.selectedProduct.id_product && product.id_channel == this.selectedProduct.id_channel ? 'active' : '')
      }
    }
  }
}
</script>

<style scoped>
    .btn-xs {
      padding: 0.1rem 0.5rem;
      font-size: 0.3rem;
    }
    .pb-10 {
        padding-bottom: 10px !important;
    }
    h6, .h6 {
        font-size: 1rem !important;
    }
    .aei-content {
        width: 100%;
    }
    .aei-timestamp {
        color: #047bf8 !important
    }
    .ae-list-w .ae-list .aei-image .user-avatar-w img {
        border-radius: 0px;
    }
    .ae-list-w .ae-list .ae-item.active .user-avatar-w {
        border-radius: 0px;
    }
    .element-search input {
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
        background-color: #fff;
        border-radius: 30px;
        padding: 10px 15px 10px 50px;
        display: block;
        width: 100%;
        outline: none;
    }
</style>
